import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import * as filterRecordsActions from './reducer';
import * as staticDataActions from '../staticData/reducer';
import * as recentlyUsedActions from '../recentlyUsed/reducer';
import FilterModal from './FilterModal';

import './Filter.css';
import { FILTER_PARAM, TYPE } from '../utility/types';

export class FilterControlComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterCoords: null,
      filterParams: this.parseFilterParams(props.location.search)
    };
    this.onFilter = this.onFilter.bind(this);
    this.onFilterDateRange = this.onFilterDateRange.bind(this);
  }

  static get propTypes() {
    return {
      setDisplayFilter: PropTypes.func,
      displayFilter: PropTypes.bool,
      onFetchClients: PropTypes.func,
      staticData: PropTypes.object,
      recentlyUsed: PropTypes.object,
      location: PropTypes.object,
      type: PropTypes.oneOf([''].concat(TYPE.values)),
      filterNavigate: PropTypes.func,
      storeToRecentlyUsed: PropTypes.func
    };
  }

  componentWillReceiveProps(props) {
    const { location } = props;
    const parsedFilterParams = this.parseFilterParams(location.search);
    this.setState({ filterParams: parsedFilterParams });
  }

  parseFilterParams(url) {
    // Remove anything from the querystring that isn't a valid filter param
    const parsed = queryString.parse(url);
    const filterParams = {};
    Object.keys(parsed).forEach((key) => {
      if (FILTER_PARAM.values.includes(key)) {
        filterParams[key] = parsed[key];
      }
    });
    return filterParams;
  }

  storeFilterParamsToRecentlyUsed(recentlyUsedKey, recentlyUsedValue) {
    const { storeToRecentlyUsed } = this.props;

    if (recentlyUsedKey && recentlyUsedValue) {
      if (Array.isArray(recentlyUsedValue)) {
        recentlyUsedValue.forEach((val) => {
          storeToRecentlyUsed(recentlyUsedKey, val);
        });
      } else {
        storeToRecentlyUsed(recentlyUsedKey, recentlyUsedValue);
      }
    }
  }

  onFilter(filterKey, value, recentlyUsedKey, recentlyUsedValue) {
    const { location } = this.props;

    this.storeFilterParamsToRecentlyUsed(recentlyUsedKey, recentlyUsedValue);

    const parsed = this.parseFilterParams(location.search);

    parsed[filterKey] = value || undefined;
    this.applyFilter(parsed);
  }

  onFilterDateRange(filterObj) {
    const { location } = this.props;
    const parsed = this.parseFilterParams(location.search);

    Object.keys(filterObj).forEach((key) => {
      parsed[key] = filterObj[key];
    });

    this.applyFilter(parsed);
  }

  applyFilter(parsedParams) {
    const { filterNavigate, location } = this.props;

    this.setState({ filterParams: parsedParams });
    const newQuerystring = queryString.stringify(parsedParams);
    const newUrl = `${location.pathname}?${newQuerystring}`;
    filterNavigate(newUrl);
  }

  onFilterButtonClick(filterKey, event) {
    const { setDisplayFilter } = this.props;
    const { bottom, left } = event.target.getBoundingClientRect();

    this.setState({ filterCoords: { top: bottom, left } });
    setDisplayFilter(true, filterKey);
  }

  renderFilterButton(label, filterKey, activeKeys) {
    const { filterParams } = this.state;
    const isActive = activeKeys
      ? activeKeys.reduce((prevValue, key) => prevValue || filterParams[key], false)
      : filterParams[filterKey];

    return (
      <div className={classnames('FilterControl-btnContainer', filterKey)}>
        <button onClick={event => this.onFilterButtonClick(filterKey, event)} className={classnames('btn filterBtn', filterKey, { active: isActive })}>{label}</button>
      </div>
    );
  }

  render() {
    const { displayFilter, setDisplayFilter,
      staticData, type, onFetchClients, recentlyUsed } = this.props;
    const { filterCoords, filterParams } = this.state;
    const STATUS = type === TYPE.ORDER ? FILTER_PARAM.ORDER_STATUS : FILTER_PARAM.RFQ_STATUS;

    return (
      <div className="FilterControl">
        <div className="FilterControl-commands-group">
          { this.renderFilterButton('Status', STATUS)}
          { this.renderFilterButton('Client', FILTER_PARAM.CLIENT)}
          { this.renderFilterButton('Instrument', FILTER_PARAM.INSTRUMENT)}
          { this.renderFilterButton('Sales Person', FILTER_PARAM.SALES_PERSON)}
          { this.renderFilterButton('Date', `${FILTER_PARAM.START_DATE}-${FILTER_PARAM.END_DATE}`,
            [FILTER_PARAM.START_DATE, FILTER_PARAM.END_DATE])}
        </div>
        <FilterModal
          filterParams={filterParams}
          onFilter={this.onFilter}
          onFilterDateRange={this.onFilterDateRange}
          coords={filterCoords}
          recentlyUsed={recentlyUsed}
          onFetchClients={onFetchClients}
          showModal={displayFilter}
          setDisplayFilter={setDisplayFilter}
          staticData={staticData}
          type={type}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  displayFilter: state.filterRecords.displayFilter,
  filterKey: state.filterRecords.filterKey,
  recentlyUsed: state.recentlyUsed.values,
  staticData: state.staticData
});

const mapDispatchToProps = (dispatch) => {
  const {
    setDisplayFilter,
    filterNavigate
  } = bindActionCreators(filterRecordsActions, dispatch);

  const {
    fetchClients
  } = bindActionCreators(staticDataActions, dispatch);

  const {
    storeToRecentlyUsed
  } = bindActionCreators(recentlyUsedActions, dispatch);

  return {
    setDisplayFilter,
    filterNavigate,
    storeToRecentlyUsed,
    onFetchClients: fetchClients
  };
};

const FilterControl = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterControlComponent));

export default FilterControl;



// WEBPACK FOOTER //
// ./src/filter/FilterControl.js